import React, { useState } from 'react';
import '../index.css';
import Navbar from '../components/navbar';

const ledgerEntries = [
  { date: '2025-2-01', value1: 'Value 1', value2: 'Value 2', value3: 'Value 3', value4: 'Value 4', value5: 'Value 5', value6: 'Value 6', value7: 'Value 7' },
  { date: '2025-2-02', value1: 'Value 1', value2: 'Value 2', value3: 'Value 3', value4: 'Value 4', value5: 'Value 5', value6: 'Value 6', value7: 'Value 7' },
  { date: '2025-2-03', value1: 'Value 1', value2: 'Value 2', value3: 'Value 3', value4: 'Value 4', value5: 'Value 5', value6: 'Value 6', value7: 'Value 7' },
  // Add more entries as needed
];

function Ledger() {
  const [hoveredRow, setHoveredRow] = useState(null);

  return (
    <div className="min-h-screen p-8 w-full">
      
      <div className="max-w-6xl mx-auto mt-8">
        <div className="bg-white bg-opacity-90 rounded-xl shadow-xl overflow-hidden">
          <div className="p-6 border-b border-green-200 bg-gradient-to-br from-green-400 to-teal-400">
            <h1 className="text-2xl font-bold text-white">Ledger</h1>
            <p className="text-sm text-green-100 mt-1">Transparent Entry of Carbon Sequestration Data, brought to you by us.</p>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-green-100 to-teal-100 text-black">
                  <th className="py-4 px-6 text-left font-medium">Date</th>
                  <th className="py-4 px-6 text-left font-medium">Value 1</th>
                  <th className="py-4 px-6 text-left font-medium">Value 2</th>
                  <th className="py-4 px-6 text-left font-medium">Value 3</th>
                  <th className="py-4 px-6 text-left font-medium">Value 4</th>
                  <th className="py-4 px-6 text-left font-medium">Value 5</th>
                  <th className="py-4 px-6 text-left font-medium">Value 6</th>
                  <th className="py-4 px-6 text-left font-medium">Value 7</th>
                </tr>
              </thead>
              <tbody>
                {ledgerEntries.map((entry, index) => (
                  <tr 
                    key={index} 
                    className={`border-b border-green-100 ${
                      hoveredRow === index ? 'bg-green-50' : index % 2 === 0 ? 'bg-white' : 'bg-green-50 bg-opacity-30'
                    } transition-colors duration-150`}
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                  >
                    <td className="py-3 px-6 font-medium text-teal-700">{entry.date}</td>
                    <td className="py-3 px-6 text-gray-700 font-bold">{entry.value1}</td>
                    <td className="py-3 px-6 text-gray-700 font-bold">{entry.value2}</td>
                    <td className="py-3 px-6 text-gray-700 font-bold">{entry.value3}</td>
                    <td className="py-3 px-6 text-gray-700 font-bold">{entry.value4}</td>
                    <td className="py-3 px-6 text-gray-700 font-bold">{entry.value5}</td>
                    <td className="py-3 px-6 text-gray-700 font-bold">{entry.value6}</td>
                    <td className="py-3 px-6 text-gray-700 font-bold">{entry.value7}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          <div className="p-4 bg-green-50 text-right">
            <button className="px-4 py-2 bg-gradient-to-r from-green-400 to-teal-500 text-white rounded-lg shadow hover:shadow-md transition-all duration-200">
              Add Entry
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ledger;